import EmojiEventsIcon from "@mui/icons-material/EmojiEvents";
import {
  Box, Chip, Table, TableBody, TableCell, TableRow, Typography,
} from "@mui/material";
import { EmptyState, PALETTE, SectionPaper, StyledTableContainer, StyledTableHead, StyledTableRow } from "../components/shared";

type Props = { leaderboard: any[]; currentStudentId: string };

const medalColor: Record<number, string> = { 1: "#FFD700", 2: "#C0C0C0", 3: "#CD7F32" };

export default function LeaderboardView({ leaderboard, currentStudentId }: Props) {
  if (!leaderboard.length) return <EmptyState message="No leaderboard data yet. Start solving to earn your rank!" />;

  return (
    <SectionPaper>
      <StyledTableContainer>
        <Table stickyHeader size="small" sx={{ tableLayout: "fixed", minWidth: 500 }}>
          <StyledTableHead>
            <TableRow>
              <TableCell sx={{ width: "8%" }}>Rank</TableCell>
              <TableCell sx={{ width: "35%" }}>Student</TableCell>
              <TableCell align="center" sx={{ width: "15%" }}>Rating</TableCell>
              <TableCell align="center" sx={{ width: "12%" }}>XP</TableCell>
              <TableCell align="center" sx={{ width: "12%" }}>Solved</TableCell>
              <TableCell align="center" sx={{ width: "18%" }}>Streak</TableCell>
            </TableRow>
          </StyledTableHead>
          <TableBody>
            {leaderboard.map((item) => {
              const isMe = item.studentId === currentStudentId;
              const medal = medalColor[item.rank];
              return (
                <StyledTableRow key={item._id ?? item.studentId}
                  sx={{ bgcolor: isMe ? "#eff6ff !important" : undefined }}>
                  <TableCell>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      {medal ? <EmojiEventsIcon sx={{ fontSize: 16, color: medal }} /> : null}
                      <Typography sx={{ fontSize: "13px", fontWeight: medal ? 800 : 400 }}>{item.rank}</Typography>
                    </Box>
                  </TableCell>
                  <TableCell>
                    <Typography sx={{ fontSize: "13px", fontWeight: isMe ? 700 : 500, color: isMe ? "primary.main" : "#374151" }}>
                      {item.displayName ?? item.studentId}
                      {isMe && <Chip size="small" label="You" sx={{ ml: 0.75, fontSize: "10px", height: "18px", bgcolor: "#dbeafe", color: "#1d4ed8" }} />}
                    </Typography>
                  </TableCell>
                  <TableCell align="center">
                    <Typography sx={{ fontSize: "13px", fontWeight: 600, color: "primary.main" }}>{item.rating}</Typography>
                  </TableCell>
                  <TableCell align="center"><Typography sx={{ fontSize: "13px" }}>{item.xp}</Typography></TableCell>
                  <TableCell align="center"><Typography sx={{ fontSize: "13px" }}>{item.solvedCount}</Typography></TableCell>
                  <TableCell align="center">
                    <Chip size="small" label={`${item.currentStreak ?? 0}d 🔥`}
                      sx={{ fontSize: "11px", height: "20px", bgcolor: (item.currentStreak ?? 0) > 0 ? "#fff7ed" : "#f8fafc", color: (item.currentStreak ?? 0) > 0 ? "#ea580c" : PALETTE.textMuted }} />
                  </TableCell>
                </StyledTableRow>
              );
            })}
          </TableBody>
        </Table>
      </StyledTableContainer>
    </SectionPaper>
  );
}
